<template>
	<div>
		<ProgressLinear v-if="loading"/>
		<div v-else>
			<v-alert dense class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
				{{ error_msg }}
			</v-alert>
			<v-row class="ma-0 px-3" justify="center">
				<v-col v-if="$vuetify.breakpoint.width > 1400" cols="1">&nbsp;</v-col>
				<v-col :cols="$vuetify.breakpoint.width > 1400 ? 10 : 12">
					<v-row class="ma-0 py-6 upload-area" align="center" justify="center">
						<v-btn class="text-capitalize px-6 py-4" :color="'#605AF6'" @click="onUpload()">
							<Upload :color="'#FFFFFF'" width="20" height="20" class="mr-2"/>
							<span style="color: #FFFFFF">Upload file</span>
							<input type="file" class="hidden" ref="updateFile" :accept="file_type.join(',')" capture @change="e => update_files(e)"/>
						</v-btn>
					</v-row>
					<v-expansion-panels v-model="panel" class="mt-2 mx-0 px-6 pb-4 files-area" flat accordion>
						<v-expansion-panel v-for="group in grouped_file_list" :key="group.date_key">
							<v-expansion-panel-header class="pa-0" style="background-color: #FAFAFA">
								<div class="file-list-title panel-header">
									{{ group.date_label }}
									<span style="font-weight: 400">({{ group.items.length }})</span>
								</div>
								<template v-slot:actions>
									<v-row class="panel-icon ma-0 pr-2" style="color: rgba(25, 42, 62, 0.7);">
										<v-icon v-if="group.is_down">mdi-chevron-up</v-icon>
										<v-icon v-if="!group.is_down">mdi-chevron-down</v-icon>
									</v-row>
								</template>
							</v-expansion-panel-header>
							<v-expansion-panel-content style="background-color: #FAFAFA">
								<template v-if="$vuetify.breakpoint.mdAndDown">
									<v-row v-for="item in group.items" :key="item.id" class="mx-0 my-3 py-1 px-3" style="background-color: #FFFFFF;" justify="space-between" align="center">
										<div>
											<div>
												<v-icon size="24" v-if="item.status === file_upload_success" color="#81CC00">mdi-check</v-icon>
												<v-icon size="24" v-else color="error">mdi-close</v-icon>
												<span class="file-list-text ml-2" :style="item.status === file_upload_success ? 'color: #81CC00':'color: #F45252'">{{ item.status === file_upload_success ? 'Success':'Failed' }}</span>
											</div>
											<div>
												<v-icon size="20" :color="'#2D00AD'" class="mr-1">mdi-file-code</v-icon>
												<span class="file-list-text">{{ item.filename }}</span>
											</div>
											<div>
												<span class="file-list-text mr-2" style="font-weight: 400">{{ item.created_by }}</span>
												<span class="file-list-text" style="font-weight: 400">{{ formatDate(item.created_on) }}</span>
											</div>
										</div>
										<div align="end">
											<v-btn depressed class="file-list-text text-capitalize white--text pl-3 pr-2" :color="color" @click="$emit('file', item.id)">
												<span class="mr-2">Go to holdings</span>
												<v-icon>mdi-arrow-right</v-icon>
											</v-btn>
										</div>
									</v-row>
								</template>
								<template v-if="!$vuetify.breakpoint.mdAndDown">
									<v-row v-for="item in group.items"  :key="item.id" class="mx-0 my-3 py-1 px-3" style="background-color: #FFFFFF;" align="center">
										<v-col cols="2" class="my-1 pa-0">
											<v-icon size="24" v-if="item.status === file_upload_success" color="#81CC00">mdi-check</v-icon>
											<v-icon size="24" v-else color="error">mdi-close</v-icon>
											<span class="file-list-text ml-2" :style="item.status === file_upload_success ? 'color: #81CC00':'color: #F45252'">{{ item.status === file_upload_success ? 'Success':'Failed' }}</span>
										</v-col>
										<v-col cols="4" class="my-1 pa-0">
											<v-icon size="20" :color="'#2D00AD'" class="mr-1">mdi-file-code</v-icon>
											<span class="file-list-text">{{ item.filename }}</span>
										</v-col>
										<v-col cols="3" class="my-1 py-0 pl-2 pr-0">
											<span class="file-list-text mr-2" style="font-weight: 400">{{ item.created_by }}</span>
											<span class="file-list-text" style="font-weight: 400">{{ formatDate(item.created_on) }}</span>
										</v-col>
										<v-col cols="1" class="my-1 pa-0" style="text-align: right;">
											<span class="file-list-text" style="font-weight: 400">
												<span style="font-weight: 500">{{ item.totallines }}</span>&nbsp;&nbsp;bookings</span>
										</v-col>
										<v-col cols="2" class="my-1 pa-0" align="end">
											<v-btn depressed class="file-list-text text-capitalize white--text pl-3 pr-2" :disabled="item.status !== file_upload_success || item.totallines === 0" :color="color" @click="$emit('file', item.id)">
												<span class="mr-2">Go to holdings</span>
												<v-icon>mdi-arrow-right</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</template>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>
				<v-col v-if="$vuetify.breakpoint.width > 1400" cols="1">&nbsp;</v-col>
			</v-row>
		</div>
		<NoticeConfirmDialog
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
			:color="notice_color"
			@ok="close()"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import Upload from "@/components/icons/upload.vue";
import NoticeConfirmDialog from "@/components/dialogs/notice_confirm_dialog.vue";

import moment from "moment-timezone";

const FILE_TYPE = ['application/json'];
const File_Upload_Success = 1;

const Exist_Text = 'File already exists.';

export default {
	name: 'MediaHoldingFileUpload',
	props: {
		color: {
			type: String,
			default: ''
		}
	},
	data() {
		this.file_type = FILE_TYPE;
		this.file_upload_success = File_Upload_Success;
		
		return {
			loading: false,
			error_msg: '',

			file_list: [],
			panel: null,

			visible_notice: false,
			notice_text: [],
			notice_color: '#00AAFD',
		}
	},
	components: {
		ProgressLinear,
		Upload,
		NoticeConfirmDialog
	},
	async created() {
		this.listHoldings();
	},
	computed: {
		grouped_file_list() {
			const groups_by_key = {};

			if (this.file_list.length === 0) {
				const date_key = moment().format('YYYY-MM-DD');

				if (!groups_by_key[date_key]) {
					groups_by_key[date_key] = [];
				}

			} else {
				this.file_list.forEach((item) => {
					const date_key = this.formatDateKey(item.created_on);
					if (!date_key) {
						return;
					}
					if (!groups_by_key[date_key]) {
						groups_by_key[date_key] = [];
					}
					groups_by_key[date_key].push(item);
				});
			}
						
			return Object.keys(groups_by_key)
				.sort((a, b) => (a < b ? 1 : -1))
				.map((date_key) => ({
					date_key,
					date_label: this.formatDateGroupLabel(date_key),
					is_down: false,
					items: groups_by_key[date_key].sort((a, b) => { return (a.filename >= b.filename ? 1 : -1) })
				}));
		},
	},
	methods: {
		async listHoldings() {
			this.loading = true;

			const three_weeks_ago = moment().subtract(3, 'weeks').format('YYYY-MM-DD');
			const url = `/api/media/media_planning/import_export/holdings_list?from_date=${three_weeks_ago}`;
			
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.file_list = data;
						this.panel = 0;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		dropFile(event) {
			let droppedFiles = event.dataTransfer.files;
			if (!droppedFiles) {
				return
			}

			([...droppedFiles]).forEach(file => {
				this.update_holdings_file(file);
			})
		},
		onUpload() {
			this.$refs.updateFile.click();
		},
		update_files(e) {
			const file = e.target.files[0];

			if (file) {
				this.update_holdings_file(file)
			}
		},
		update_holdings_file(file) {
			const reader = new FileReader();
			reader.readAsText(file,'utf-8');

			reader.onload = readerEvent =>  {
				const json_data = readerEvent.target.result;

				const json_data_parse = JSON.parse(json_data);
				const json_data_summary = json_data_parse.Holdings.Summary;


				const params = [];
				params.push("generation_date=" + encodeURIComponent(json_data_summary.GenerationDate.toString()) );
				params.push("agency_group_code=" + json_data_summary.AgencyGroupCode.toString());
				params.push("network_code=" + json_data_summary.NetworkCode.toString());

				let url = '/api/media/media_planning/import_export/check_holding_file_exists';

				if (params.length > 0) {
					url+= "?" + params.join('&');
				}

				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const {status, data, reason } = val.data;
						if (status == "OK") {
							if (!data) {
								this._update_holdings_file(file.name, json_data);
							} else {
								this.notice_text = [];
								this.notice_text = [Exist_Text];
								this.visible_notice = true;
							}
						} else {
							this.error_msg = reason;
						}
					})
					.catch(e => {
						this.error_msg = e.message;
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		_update_holdings_file(file_name, json_data) {
			let url = "/api/media/media_planning/import_export/holdings_file";

			const params = [];
			params.push("file_name=" + file_name);

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}	
				
			axios
				.post(url, json_data, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.listHoldings();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		formatDate(date_str) {
			let date = '';

			if (typeof(date_str) === 'string' && date_str.length !== 0) {
				date = moment(date_str).format('DD MMM YYYY HH:mm');
			}
      
			return date
		},
		formatDateKey(date_str) {
			if (typeof(date_str) !== 'string' || date_str.length === 0) {
				return '';
			}
			return moment(date_str).format('YYYY-MM-DD');
		},
		formatDateGroupLabel(date_key) {
			if (typeof(date_key) !== 'string' || date_key.length === 0) {
				return '';
			}
			return moment(date_key, 'YYYY-MM-DD').format('DD MMM YYYY');
		},
		close() {
			this.visible_notice = false;
			this.notice_text = [];
		}
	}
}
</script>

<style lang="scss" scoped>
.upload-area {
  height: 100px;
}
.files-area {
	border: 1px solid rgba(96, 90, 246, 0.5);
	background-color: #FAFAFA;
}
.drag-drop-text {
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  color: rgba(71, 66, 198, 1);
}
.drag-drop-text-sub {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-align: center;
  color: rgba(96, 90, 246, 0.5);
}
.hidden {
	display: none;
}
.file-list-title {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #192A3E;
}
.file-list-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0.5px;
  color: #192A3E;
}
.table-wrap {
	height: calc(100vh - 210px);
	overflow: auto;
}
.table-wrap-container {
  height: 99%;
}
.panel-icon {
	order: 0;
}
.panel-header {
	order: 1;
}
::v-deep {
	.save-btn.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: rgba(96, 90, 246, 0.2) !important;
	}
	.save-btn.v-btn.v-btn--disabled {
		color: #FFFFFF !important;
	}
	.v-expansion-panel-content__wrap {
		padding: 0 !important;
	}
	.v-expansion-panel--active > .v-expansion-panel-header {
		min-height: 48px !important;
	}
}
</style>